import { createContext, useContext } from 'react'

export type ExistingValues = Record<string, unknown> | undefined
export type ExistingValuesContextType<T> = {
  existingValues?: T
  getExistingValue: (name: string) => unknown
}

/** Configuration context for a life App. */
const ExistingValuesContext =
  createContext<ExistingValuesContextType<ExistingValues> | null>(null)

const useExistingValuesContext = <T>() => {
  const context = useContext(ExistingValuesContext)

  return (context ?? {}) as Partial<ExistingValuesContextType<T>>
}
const Provider = ExistingValuesContext.Provider

export { Provider, useExistingValuesContext }
